import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Pressable, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Text } from '@/components/ui/text';

interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
  fullScreen?: boolean;
  icon?: keyof typeof Ionicons.glyphMap;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  error,
  onRetry,
  fullScreen = true,
  icon = 'alert-circle-outline'
}) => {
  const content = (
    <View className="flex-1 justify-center items-center px-4">
      <Ionicons
        name={icon}
        size={64}
        className="text-muted-foreground"
        style={{ marginBottom: 16 }}
      />
      <Text className="text-center mb-4 text-foreground">
        {error}
      </Text>
      {onRetry && (
        <Pressable
          onPress={onRetry}
          className="px-4 py-2 rounded-lg bg-primary"
        >
          <Text className="text-sm font-medium">
            Retry
          </Text>
        </Pressable>
      )}
    </View>
  );

  if (fullScreen) {
    return (
      <SafeAreaView className="flex-1">
        {content}
      </SafeAreaView>
    );
  }

  return content;
};

export default ErrorState;
